import {Component, DestroyRef, EventEmitter, inject, OnInit, Output, ViewEncapsulation} from '@angular/core';
import { FormControl } from '@angular/forms';
import { filter } from 'rxjs/operators';
import * as RA from 'ramda-adjunct';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {FeatureScope} from '@emm/core/util/feature-scope.constants';
import {AuthFacadeService} from '@emm/auth/services/auth-facade.service';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-scope-picker',
    templateUrl: './scope-picker.component.html',
    styleUrls: ['./scope-picker.component.scss'],
    standalone: false
})
export class ScopePickerComponent implements OnInit {

    private readonly destroyRef: DestroyRef = inject(DestroyRef);

    @Output() featureScopeSelected = new EventEmitter<string>();

    featureScopeCtrl = new FormControl(FeatureScope.Viewer);
    featureScopes = [
        { id: FeatureScope.Viewer, name: 'Menu Viewer' },
        { id: FeatureScope.Global, name: 'Global Menu Builder' },
        { id: FeatureScope.Client, name: 'Consumer Menu Assignment' },
    ];
    isReadonly$ = this.authFacade.isReadOnly$
        .pipe(
            takeUntilDestroyed(this.destroyRef)
        );

    constructor(private authFacade: AuthFacadeService) {}

    ngOnInit(): void {
        this.isReadonly$.subscribe();
        this.featureScopeCtrl.valueChanges
            .pipe(filter(RA.isNotNil), takeUntilDestroyed(this.destroyRef))
            .subscribe(this.featureScopeSelected);
    }



    get placeholderText(): string {
        return `Select Menu Mode`;
    }

}
